import React, { useEffect, useState } from "react";
import axios from "axios";
import { useApp, API } from "@/contexts/AppContext";
import { ScrollText } from "lucide-react";

export default function SuperAudit() {
  const { t } = useApp();
  const [logs, setLogs] = useState([]);
  useEffect(() => { axios.get(`${API}/audit-logs`).then((r) => setLogs(r.data)).catch(() => {}); }, []);

  const fmt = (d) => new Date(d).toLocaleString("fr-FR", { dateStyle: "short", timeStyle: "medium" });
  const actionColor = (a) => {
    if (a.includes("delete") || a.includes("inactive")) return "#C62828";
    if (a.includes("create") || a.includes("active") || a.includes("approve")) return "#2E7D32";
    if (a.includes("login") || a.includes("note")) return "#1E4631";
    return "#5C6B61";
  };

  return (
    <div className="space-y-6" data-testid="super-audit">
      <h1 className="text-3xl font-[Outfit] font-bold">{t.super.audit}</h1>
      <div className="bg-white rounded-xl border border-[#E5EBE7] divide-y divide-[#E5EBE7]">
        {logs.length === 0 ? (
          <div className="p-12 text-center text-[#5C6B61]" data-testid="empty-audit">Aucun log</div>
        ) : logs.map((l) => (
          <div key={l.id} className="p-4 hover:bg-[#FDFBF7]/50" data-testid={`audit-${l.id}`}>
            <div className="flex items-start gap-3">
              <div className="w-8 h-8 rounded-full grid place-items-center" style={{ background: `${actionColor(l.action)}15`, color: actionColor(l.action) }}>
                <ScrollText className="w-4 h-4"/>
              </div>
              <div className="flex-1 text-sm">
                <div className="flex items-center gap-2 flex-wrap">
                  <span className="font-mono text-xs px-2 py-0.5 rounded bg-[#FDFBF7]" style={{ color: actionColor(l.action) }}>{l.action}</span>
                  <span className="font-medium">{l.user_email}</span>
                  <span className="text-[10px] uppercase tracking-wide px-1.5 rounded bg-[#1E4631]/10 text-[#1E4631]">{l.user_role}</span>
                  <span className="text-[#5C6B61] ml-auto text-xs">{fmt(l.timestamp)}</span>
                </div>
                {(l.target_type || l.details) && (
                  <div className="mt-1 text-xs text-[#5C6B61]">
                    {l.target_type && <span>cible: {l.target_type}</span>}
                    {l.details && <span> · {l.details}</span>}
                  </div>
                )}
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
